import { iconCodes } from '@app/shared/cqes-icon/cqes-icon.component';
import { IStatusIcon } from '@app/shared/interfaces/common-interfaces';

export type ConsentRequest = {
    certReqIds: string[];
    status?: string;
    offset?: number;
    limit?: number;
};

export interface IConsentElement {
    id: number;
    consentId: number;
    orgName: string;
    roleName: string;
    createdDate: number;
    expirationDate: number;
    revokeReason: string;
    status: ConsentStatus;
}

export enum ConsentStatus {
    ALL = 'ALL',
    ACTIVE = 'ACTIVE',
    REVOKED = 'REVOKED',
    AUTO_REVOKED = 'AUTO_REVOKED',
    INACTIVATED = 'INACTIVATED'
}

export const consentStatusMap = {
    ALL: {
        icon: {} as IStatusIcon,
        text: 'consentsTexts.all'
    },
    ACTIVE: {
        icon: {
            icon: iconCodes.done,
            colorClass: 'text-success',
            tooltip: 'consentsTexts.active'
        },
        text: 'consentsTexts.active'
    },
    REVOKED: {
        icon: {
            icon: iconCodes.blocked,
            colorClass: 'text-danger',
            tooltip: 'consentsTexts.revoked'
        },
        text : 'consentsTexts.revoked'
    },
    AUTO_REVOKED: {
        icon: {
            icon: iconCodes.cancel,
            colorClass: 'text-danger',
            tooltip: 'consentsTexts.autoRevoked'
        },
        text: 'consentsTexts.autoRevoked'
    },
    INACTIVATED: {
        icon: {
            icon: iconCodes.error,
            colorClass: 'text-danger',
            tooltip: 'consentsTexts.inactivated'
        },
        text: 'consentsTexts.inactivated'
    }
};
